import { Collapse } from '@mui/material';

import { InstallableKentFeature } from '@cast/types-kent';

import { AgentCostSetup } from 'hooks/dialogs/cluster/components/features';

import { KentFeatureItem } from './KentFeatureItem';
import { KentFeaturesSelection } from './KentFeaturesSelection';
import { ToggleButton } from './ToggleButton';
import { SelectedFeatures } from '../../_types';

import { Box, Stack } from '@cast/design-system';

type Props = {
  selectedFeatures: SelectedFeatures;
  featureBeingInstalled?: InstallableKentFeature['type'];
  isExpanded: boolean;
  kentFeatures?: InstallableKentFeature[];
  onToggleSection: () => void;
  onToggleFeature: (feature: InstallableKentFeature['type']) => void;
  onToggleKentSuite: (shouldCheck: boolean) => void;
};

export const CustomizeFeaturesSection = ({
  selectedFeatures,
  isExpanded,
  featureBeingInstalled,
  kentFeatures,
  onToggleSection,
  onToggleFeature,
  onToggleKentSuite,
}: Props) => {
  return (
    <Stack data-testid="customize-features-section">
      {featureBeingInstalled && (
        <KentFeatureItem
          testId="feature-being-installed-item"
          readonly
          featureType={featureBeingInstalled}
          checked={selectedFeatures[featureBeingInstalled]}
          hasBeenInstalled={false}
        />
      )}
      <Box mb={16}>
        <ToggleButton
          testId="customize-features-toggle"
          title={
            featureBeingInstalled ? 'Other features' : 'Customize features'
          }
          isExpanded={isExpanded}
          onToggle={onToggleSection}
        />
      </Box>

      <Collapse in={isExpanded} unmountOnExit>
        <Stack gap={8} data-testid="customize-features-collapsible-content">
          <Stack>
            <AgentCostSetup checked readonly />
            <KentFeaturesSelection
              featureBeingInstalled={featureBeingInstalled}
              kentFeatures={kentFeatures}
              selectedFeatures={selectedFeatures}
              onToggleFeature={onToggleFeature}
              onToggleKentSuite={onToggleKentSuite}
            />
          </Stack>
        </Stack>
      </Collapse>
    </Stack>
  );
};
